import Link from "next/link";
import Grid from "@mui/material/Unstable_Grid2";
import { Box, Card, CardActions, CardContent, Chip, Rating, Skeleton, Stack, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import Image from "next/image";

interface Props {
  handleProductClick: (item: any, itemList: { itemListId: string; itemListName: string }) => void;
  item: any
  index: number
  itemList: any
}

const CardProduct: React.FC<Props> = ({ handleProductClick, item, index, itemList }) => {

  const imgDefault = "/assets/images/logo/logomaboom.png"
  const [isLoading, setIsLoading] = useState(false);

  return (
    <Link
      key={item.id}
      // href={`/product/${item.product_slug}?store=${item.store_id}&id=${item.product_id}`}
      href={{
        pathname: `/product/${item.product_slug}`,
        query: { store: item.store_id, id: item.id },
      }}
      style={{ cursor: 'pointer', height: "100%" }}
    >
      <Card
        className="product-card-best"
        sx={{
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          borderRadius: '14px',
          transition: 'transform 0.3s, border 0.3s',
          '&:hover': {
            borderColor: "#f6cd64",
            transform: 'translateY(-2px)',
          },
        }}
      >
        <Box sx={{ textAlign: "center", position: "relative", width: '100%' }}>
          <Box sx={{ width: '100%', paddingBottom: '100%', position: 'relative' }}>
            <Image
              src={item?.product_thumbnail_image_url || imgDefault}
              alt={item?.product_title || imgDefault}
              fill
              // priority
              style={{ objectFit: 'cover' }}
              loading="lazy"
              placeholder="empty"
              blurDataURL={item?.product_thumbnail_image_url || imgDefault}
            />
          </Box>
          {item?.product_in_campaign && (
            <img
              src={item.product_in_campaign?.campaign_product_join?.frame_product_fullpath || imgDefault}
              alt="Frame Product"
              style={{
                position: "absolute",
                zIndex: 9,
                top: "10px",
                left: "0px",
                width: "100%",
              }}
            />
          )}
        </Box>
        <CardContent sx={{ height: "100%", padding: "10px" }}>
          <Typography
            sx={{
              my: 1,
              display: '-webkit-box',
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              WebkitLineClamp: 2,
              whiteSpace: 'normal',
              color: "#717171",
              fontSize: "14px"
            }}
          >
            {item.product_title}
          </Typography>
          <Stack direction="row" sx={{ display: "inline-block", width: "100%" }}>
            <Typography
              sx={{ fontSize: "18px", lineHeight: "20px", marginBottom: 0, display: "inline-block" }}
              className="txt-bold"
              gutterBottom
              color="secondary"
            >
              {item.product_discounted_price == null || item.product_discounted_price === 0
                ? `฿${new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(item.product_normal_price)}`
                : `฿${new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(item.product_discounted_price)}`}
            </Typography>
            {item.product_discounted_price > 0 && (
              <Typography
                sx={{
                  fontSize: "12px",
                  display: "inline-block",
                  textDecoration: "line-through",
                  pl: 1,
                  mt: 0.7,
                  fontWeight: "bold",
                  lineHeight: "14px",
                  color: "#AEAEAE",
                  marginTop: 0,
                }}
              >
                ฿{item.product_normal_price.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
              </Typography>
            )}
          </Stack>
          {item?.product_percentage_discount > 0 && (
            <Chip
              color="primary"
              size="small"
              label={`ส่วนลด ${Math.trunc(item?.product_percentage_discount)}%`}
            />
          )}
        </CardContent>
        <CardActions sx={{
          justifyContent: "space-between",
          display: "inline-block",
          padding: '5px 15px'
        }}>
          <Box display="inline-flex" sx={{ alignItems: 'center' }}>
            {item.product_score > 0 && (
              <Rating
                name="read-only"
                value={item.product_score ?? 0}
                precision={0.5}
                readOnly
                size="small"
                sx={{ fontSize: 12 }}
                max={1}
              />
            )}
            {item.product_score > 0 && (
              <Typography
                variant="caption"
                sx={{ mr: 1, ml: 1, fontSize: 10 }}
              >
                {item.product_score}
              </Typography>
            )}
          </Box>
          {item.product_sold > 0 && (
            <Typography
              variant="caption"
              color="text.secondary"
              sx={{ fontSize: 10, marginLeft: "0 !important", float: "right" }}
            >
              ขายแล้ว {item.product_sold} ชิ้น
            </Typography>
          )}
        </CardActions>
      </Card>
    </Link>
  )
}

export default CardProduct